import { createFileRoute } from '@tanstack/react-router'
import { stockAdjustmentQueryOptions } from '../../../features/inventory/queries'
import { StockAdjustmentDetailPage } from '../../../features/inventory/stock-adjustment-pages'

export const Route = createFileRoute('/_app/stock-adjustments/$adjustmentId')({
  staticData: { crumb: 'stockAdjustment' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(stockAdjustmentQueryOptions(params.adjustmentId)),
  component: StockAdjustmentDetailPage,
})
